import groq from 'groq';

export const MITOPURE_ELABORATION = groq`
  _type,
  title
`;

export const MITOPURE_ELABORATION_BLOCK = groq`
  _type == 'timeline_mitopureElaboration' => {
    ${MITOPURE_ELABORATION}
  }
`;
